<script>
    import OrdersCollection from '../components/orders/OrdersCollection.vue';

    export default {
      components: { OrdersCollection },
    };
</script>